module.exports = __webpack_public_path__ + "img/target.a8bb5766.png";